import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import LanguageIcon from '@mui/icons-material/Language'

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'de', label: 'Deutsch' }
]

export const LOCALE_MAP = {
  en: 'en_GB',
  ar: 'ar_AE',
  fr: 'fr_FR',
  es: 'es_ES',
  it: 'it_IT',
  de: 'de_DE'
}

export const getLocale = lang => LOCALE_MAP[lang] || 'en_GB'

export default function LanguageSwitcher () {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)
  const current = i18n.resolvedLanguage || i18n.language || 'en'

  const handleSelect = code => {
    setAnchorEl(null)
    const { pathname, search, hash } = window.location
    const onArabicPath = pathname === '/ar' || pathname.startsWith('/ar/')

    // Leaving an /ar shareable URL reverts to the normal (unprefixed) flow.
    if (onArabicPath && code !== 'ar') {
      localStorage.setItem('peaks_lang', code)
      const stripped = pathname.replace(/^\/ar(?=\/|$)/, '') || '/'
      window.location.replace(`${stripped}${search}${hash}`)
      return
    }

    if (code !== current) {
      localStorage.setItem('peaks_lang', code)
      i18n.changeLanguage(code)
    }
  }

  return (
    <Box sx={{ position: 'fixed', bottom: 'calc(16px + var(--bottom-action-bar, 0px))', right: 16, zIndex: 1300 }}>
      <Button
        onClick={e => setAnchorEl(e.currentTarget)}
        size={window.matchMedia && window.innerWidth <= 576 ? 'small' : 'medium'}
        startIcon={<LanguageIcon />}
        aria-haspopup='true'
        aria-label={i18n.t('common:languageSelect')}
        sx={{
          fontWeight: 600,
          color: 'white !important',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          textShadow: '1px 1px 1px rgba(0,0,0,0.5)',
          textTransform: 'uppercase',
          '& .MuiButton-startIcon': {
            marginInlineEnd: 1
          }
        }}
      >
        {current}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {LANGUAGES.map(({ code, label }) => (
          <MenuItem
            key={code}
            selected={code === current}
            onClick={() => handleSelect(code)}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
